import { z } from "zod";
import { noAnswerSchema, type FieldDescriptor } from "./types.js";

const configSchema = z.object({
  nextButtonLabel: z.string().max(60).optional(),
});

export const pageBreakField: FieldDescriptor<z.infer<typeof configSchema>> = {
  type: "page_break",
  label: "Page break",
  category: "layout",
  icon: "SeparatorHorizontal",
  configSchema,
  valueSchema: () => noAnswerSchema(),
  defaultConfig: {},
  supportsProfileBinding: false,
  defaultSearchable: false,
  renderHints: { isLayoutOnly: true },
};
